import {
  CheckCircleOutlined,
  PhonelinkOffOutlined,
  ErrorOutlined,
  GppMaybeOutlined,
  KeyOffOutlined,
  SystemUpdateAltOutlined,
} from '@mui/icons-material'
import { Chip, CircularProgress, Tooltip } from '@mui/material'
import { FunctionComponent } from 'react'

import { UseIsiPrintResult } from '../../hooks/useIsiPrint.ts'
import { ISI_PRINT_ESTADO_LABEL } from '../../services/isiPrintClient.ts'

interface Props {
  isi: UseIsiPrintResult
}

/**
 * Indicador compacto del estado de isi-print en este equipo
 */
const IsiPrintEstadoChip: FunctionComponent<Props> = ({ isi }) => {
  const label = ISI_PRINT_ESTADO_LABEL[isi.estado]
  switch (isi.estado) {
    case 'VERIFICANDO':
      return <Chip size="small" variant="outlined" icon={<CircularProgress size={14} />} label={label} />
    case 'LISTO': {
      const n = isi.impresoras.length
      return (
        <Tooltip title={`Versión ${isi.version ?? '-'}${isi.detalle ? ` · ${isi.detalle}` : ''}`}>
          <Chip
            size="small"
            color="success"
            variant="outlined"
            icon={<CheckCircleOutlined />}
            label={`${label} · ${n} impresora${n === 1 ? '' : 's'}`}
          />
        </Tooltip>
      )
    }
    case 'NO_SOPORTADO':
      return (
        <Tooltip title={isi.detalle ?? ''}>
          <Chip size="small" variant="outlined" icon={<PhonelinkOffOutlined />} label={label} />
        </Tooltip>
      )
    case 'PENDIENTE_AUTORIZAR':
      return (
        <Chip size="small" color="warning" variant="outlined" icon={<GppMaybeOutlined />} label={label} />
      )
    case 'SIN_LICENCIA':
      return (
        <Tooltip title={isi.detalle ?? ''}>
          <Chip size="small" color="warning" variant="outlined" icon={<KeyOffOutlined />} label={label} />
        </Tooltip>
      )
    case 'ACTUALIZACION_REQUERIDA':
      return (
        <Chip
          size="small"
          color="error"
          variant="outlined"
          icon={<SystemUpdateAltOutlined />}
          label={label}
        />
      )
    default:
      return <Chip size="small" color="error" variant="outlined" icon={<ErrorOutlined />} label={label} />
  }
}

export default IsiPrintEstadoChip
